var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg18",
    width: 144.614,
    height: 104.95948,
    viewBox: "0 0 144.614 104.95948",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(100.35406,0,0,-100.35406,86.938217,127.76752)",
    spreadMethod: "pad",
    id: "linearGradient44"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5500c4"
    },
    offset: 0,
    id: "stop38"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5500c4"
    },
    offset: 0.11464466,
    id: "stop40"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ea63ff"
    },
    offset: 1,
    id: "stop42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(108.2031,0,0,-108.2031,77.540512,127.76731)",
    spreadMethod: "pad",
    id: "linearGradient66"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6d1fff"
    },
    offset: 0,
    id: "stop60"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6d1fff"
    },
    offset: 0.11477006,
    id: "stop62"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0fffcb"
    },
    offset: 1,
    id: "stop64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "matrix(1.3333333,0,0,-1.3333333,-120.40928,191.29545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1.0479719,0,0,1.0479719,2.4900597,-29.785407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 106.421,165.326 29.439,-64.861 c 3.949,-8.761 14.251,-12.663 23.012,-8.714 v 0 c 4.024,1.813 7.022,4.968 8.706,8.698 v 0 c -0.007,-0.011 -0.015,-0.021 -0.022,-0.032 v 0 c 0.007,0.017 0.015,0.032 0.022,0.048 v 0 l 18.166,40.308 h 0.008 c 2.134,4.737 1.975,9.924 -0.007,14.314 v 0 c -5.495,8.431 -9.671,6.619 -10.704,4.266 v 0 c 1.075,-2.415 1.088,-5.405 -0.268,-8.415 v 0 l 0.002,-0.007 -0.01,0.009 -20.302,-44.705 c -1.071,-2.356 -4.418,-2.356 -5.487,0 v 0 l -26.915,59.091 z",
    style: {
      fill: "url(#linearGradient44)",
      stroke: "none"
    },
    id: "path46"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "matrix(1.0479719,0,0,1.0479719,2.4900597,-29.785407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 154.026,155.07 -22.211,-48.836 c -1.07,-2.355 -4.417,-2.355 -5.487,0 v 0 L 99.413,165.326 H 83.797 l 29.416,-64.862 c 3.947,-8.76 14.25,-12.662 23.011,-8.713 v 0 c 4.025,1.813 7.022,4.968 8.706,8.697 v 0 c -0.007,-0.01 -0.015,-0.021 -0.022,-0.031 v 0 c 0.007,0.016 0.015,0.032 0.022,0.047 v 0 l 23.984,53.116 c 3.303,7.328 11.906,8.5 16.83,1.506 v 0 c -1.684,3.73 -4.682,6.885 -8.707,8.699 v 0 c -2.32,1.045 -4.748,1.541 -7.139,1.541 v 0 c -6.634,0 -12.97,-3.815 -15.872,-10.256",
    style: {
      fill: "url(#linearGradient66)",
      stroke: "none"
    },
    id: "path68"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee0de290aa34197c12db4c58bdff14a1.svg";
export { ForwardRef as ReactComponent };